.input-button {
    position: relative;
    margin-bottom: 8px;
}

.input-button:last-child {
    margin-bottom: 0;
}

.input-button label {
    display: block;
    border: 1px solid var(--off-white-dk);
    background-color: #fff;
    border-radius: 8px;
    padding: 12px 16px 12px 40px;
    cursor: pointer;
    font-size: var(--font-normal);
}

.input-button input[type='checkbox'],
.input-button input[type='radio'] {
    position: absolute;
    left: 16px;
    top: 50%;
    margin-right: 8px;
    outline: none;
    /* For some reason, this is required to actually click on the input itself */
    z-index: 1;
    transform: translateY(-50%);
}

.input-button.is-large input[type='checkbox'],
.input-button.is-large input[type='radio'] {
    transform: translateY(-50%) scale(1.5);
}

.input-button:hover label {
    border-color: #ccc;
}

/* On mouse down, move the button down by 1px */
.input-button input:active + label {
    transform: translateY(1px);
}

.input-button input:active {
    transform: translateY(calc(-50% + 1px));
}

.input-button.is-large input:active {
    transform: translateY(calc(-50% + 1px)) scale(1.5);
}

.input-button input:focus + label {
    box-shadow: 0 0 0 2px hsla(220, 80%, 60%, 0.1);
}

.input-button input:checked + label {
    border: 2px solid var(--blue);
    /* Take into account increased border size */
    padding: 11px 15px 11px 39px;
    background-color: var(--info-bg);
}

.input-button:hover input:checked + label {
    border: 2px solid var(--blue-dk);
}

/* New styles for radio icon button */
.input-button-icon {
    position: relative;
    margin-bottom: 6px;
}

.input-button-icon:last-child {
    margin-bottom: 0;
}

.input-button-icon label {
    display: block;
    border: 1px solid var(--off-white-dk);
    background-color: #fff;
    border-radius: 3px;
    padding: 12px 16px 12px 48px; /* Adjusted padding for icon */
    cursor: pointer;
    font-size: var(--font-normal);
}

.input-button-icon .icon-container {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
}

.input-button-icon:hover label {
    border-color: #ccc;
}

.input-button-icon.checked label {
    border: 2px solid var(--blue);
    padding: 11px 15px 11px 47px; /* Adjusted for 2px border */
    background-color: var(--info-bg);
}

.input-button-icon:hover.checked label {
    border: 2px solid var(--blue-dk);
}
